import { Alert, AlertDescription } from '@brent/core-ui/ui'

interface MembersOnlyNoticeProps {
  title: string
}

/**
 * Shown in place of surveys and voting to a login without the `member` group.
 */
export default function MembersOnlyNotice({ title }: MembersOnlyNoticeProps) {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl sm:text-3xl font-bold">{title}</h1>
      <Alert>
        <AlertDescription>
          {title} is open to playing members of the orchestra only. If you think this is a mistake,
          please contact the orchestra.
        </AlertDescription>
      </Alert>
    </div>
  )
}
